<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1400px"
      unit="商城销售退货单"
      :edit-title="!readonly"
      id-key="commentId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save2"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :show-save-button="!readonly"
      :close-on-saved="false"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="OrderNo">
              <el-input
                v-model="data.OrderNo"
                :placeholder="readonly?'':'请输入单据编号'"
                :disabled="readonly"
                v-if="noEdit"
              ></el-input>
              <span v-else>{{ data.OrderNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <el-date-picker
                style="width: 100%;"
                size="mini"
                v-model="data.DocDate"
                :placeholder="readonly?'':'请选择日期'"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :editable="false"
                v-if="!readonly"
              ></el-date-picker>
              <span v-else>{{data.DocDate?data.DocDate.split(" ")[0]:''}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户名称" prop="CustomerId">
              <!-- <el-input
                v-model="data.CustomerName"
                @focus="addUnit"
                :placeholder="readonly?'':'请选择'"
                readonly
                :disabled="true"
              ></el-input> -->
              <customer  @restaurants='setSupplier' :state='data.CustomerName' v-if="!edit"/>
              <span v-else>{{data.CustomerName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款条件" prop="ReceiptConditionId">
              <el-select style="width: 100%;" size="mini" v-model="data.ReceiptConditionId" :placeholder="readonly?'':'请选择'" clearable :disabled="readonly">
                <el-option v-for="item in recCon" :key="item.ReceiptConditionId" :label="item.ReceiptConditionName" :value="item.ReceiptConditionId"></el-option>
            </el-select>
            </el-form-item>
          </el-col>
                   <el-col :span="6" style="clear:both;">
            <el-form-item label="预计交货时间" prop="DeliveryDate">
              <el-date-picker
                size="mini"
                style="width: 100%;"
                v-model="data.DeliveryDate"
                :placeholder="readonly?'':'请选择日期'"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :editable="false"
                v-if="!readonly"
              ></el-date-picker>
              <span v-else>{{data.DeliveryDate?data.DeliveryDate.split(" ")[0]:''}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item label="订单来源" prop="Source">
              <el-select
                style="width: 100%;"
                size="mini"
                v-model="data.Source"
                :placeholder="readonly?'':'请选择'"
                clearable
                :disabled="readonly"
                width="220px"
              >
                <!-- <el-option label="线上" :value="1"></el-option> -->
                <el-option label="线下" :value="0"></el-option>
              </el-select>
              <!-- <span v-else>{{data.Source==0?"线下":"线上"}}</span> -->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务员" prop="ClerkName">
              <el-input style="width: 100%;" v-model="data.ClerkName" @focus="addEmp" readonly  :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="销售单号" prop="SourceOrderId">
              <div @click="addOrder" v-if="!edit">
                 <el-input style="width: 100%;"  v-model="data.SourceOrderNo" :placeholder="readonly?'':'请选择销售单号'" :disabled="readonly" readonly  ></el-input>
              </div>
              <span v-else>{{data.SourceOrderNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="买家备注" prop="BuyerRemark">
              <el-input
                type="textarea"
                v-model="data.BuyerRemark"
                :placeholder="readonly?'':'请输入备注'"
                :disabled="readonly"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input
                type="textarea"
                v-model="data.Remark"
                :placeholder="readonly?'':'请输入备注'"
                :disabled="readonly"
              ></el-input>
            </el-form-item>
          </el-col>
          <dialog-list :showTax="data.ShowTax" ref="dialogList" :info="data" :readonly="readonly" @getList="getList" />
          <el-col :span="6">
            <el-form-item label="物流费用" prop="ActualFreight">
              <span>{{ data.ActualFreight }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="优惠券" prop="CouponCustomerId">
              <!-- <el-select size="mini" v-model="data.CouponCustomerId" placeholder="请选择" clearable>
            </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="无税金额" prop="NoTaxAmount">
              <span>{{ $commonJs.toThousands(data.NoTaxAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税额" prop="TaxAmount">
              <span>{{ $commonJs.toThousands(data.TaxAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单金额" prop="Amount">
              <span>{{ $commonJs.toThousands(data.Amount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款金额" prop="ReceiptAmount">
              <span>{{ $commonJs.toThousands(data.ReceiptAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="剩余金额" prop="RemainAmount">
              <span>{{ $commonJs.toThousands(data.RemainAmount) }}</span>
            </el-form-item>
          </el-col>

          <el-row>
            <el-row>
              <el-col :span="24">
                <el-divider />
                <span style="margin-left: 16px; line-height: 50px"
                  >收款信息</span
                >
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  size="mini"
                  circle
                  @click="add"
                  v-if="!readonly"
                  style="float: right; margin: 10px 15px 10px 0"
                ></el-button>
              </el-col>
            </el-row>
            <el-row v-for="(item, index) in recList" :key="index">
              <el-col :span="6">
                <el-form-item label="结算方式" prop="SettleId">
                  <el-select
                    size="mini"
                    v-model="item.SettleId"
                    :placeholder="readonly?'':'请选择'"
                    clearable
                    :disabled="readonly"
                    @change="saChange(index)"
                  >
                  <el-option v-for="set in settleList" :key="set.SettleId" :label="set.SettleName" :value="set.SettleId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="收款账号" prop="AccountId">
                  <el-select
                    size="mini"
                    v-model="item.AccountId"
                    :placeholder="readonly?'':'请选择'"
                    clearable
                    :disabled="readonly"
                    @change="saChange(index)"
                  >
                  <el-option v-for="acc in accountList" :key="acc.AccountId" :label="acc.Bank+acc.AccountNumber" :value="acc.AccountId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="收款金额" prop="ReceiptAmount">
                  <el-input v-model="item.ReceiptAmount" type="number" @blur="onBlur(item,'ReceiptAmount')" @focus="onFocus(item,'ReceiptAmount')" :disabled="readonly" @input="recChange(index)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-link :underline="false" @click="del(index)" v-if="!readonly"
                  ><i
                    class="el-icon-delete"
                    style="
                      margin-left: 30px;
                      line-height: 30px;
                      font-size: 18px;
                    "
                  ></i
                ></el-link>
              </el-col>
            </el-row>
          </el-row>
        </el-row>
      </template>
      <template slot="footer">
        <el-button size="mini" type="danger" @click="cancelExamine" v-if="data.Status==2&&canExa">弃 审</el-button>
        <el-button size="mini" type="danger" @click="examine" v-else-if="canExa">通 过</el-button>
        <el-button size="mini" @click="closeFun" v-if="readonly">关 闭</el-button>
      </template>
    </common-dialog>
     <order-dialog ref="orderDialog" in-dialog selectable @select="setOrder" :source="0" :billType="0"/>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <unit-dialog ref="unitDialog" in-dialog selectable @select="setUnit" title='客户列表' :typeList="[1,2]" />
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dialogList from "./dialogList";
import empDialog from "@/components/sales/business/empDialog";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import orderDialog from "@/components/mall/worder/allSaOrder/orderListDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    empDialog,
    unitDialog,
    orderDialog,
    customer
  },
  data() {
    return {
      data: {
        OrderId: 0,
        CustomerId: null,
        CustomerName: "",
        CustomerType: null,
        OrderNo: "",
        DocDate: "",
        Status: 0,
        Source: 0,
        BuyerRemark: "",
        Remark: "",
        ActualFreight: 0,
        CouponCustomerId: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        ReceiptAmount: 0,
        Amount: 0,
        RemainAmount: 0,
        ReceiptConditionId: null,
        ClerkName: "",
        ClerkId: 0,
        DeliveryDate:"",
        DisposeTax:null,
        ShowTax:0,
        SourceOrderNo:"",
        SourceOrderId:"",
        SourceOrderType:0,
        Receipts:[],
        Goods:[]
      },
      SourceOrderNo:"",
      noEdit: false,
      canExa: false,
      recList: [],
      recDel: [],
      tableData: [],
      accountList: [],
      settleList: [],
      recCon: [],
      cList: [],
      eqType: null,
      // PriAdjustEmpList: [],
      api: require("@/api/sale/sales").default,
      recApi: require("@/api/sy/RecCon").default,
      settleApi: require("@/api/sale/settle").default,
      accountApi: require("@/api/sale/account").default,
      billApi: require("@/api/sy/bill").default,
      optApi: require("@/api/sy/opt").default,
      readonly: false,
      rules: {
        Source: [{ required: true, message: "订单来源不能为空" }],
        WholesalerId: [{ required: true, message: "客户名称不能为空" }],
        SourceOrderId: [{ required: true, message: "销售单号不能为空" }],
      },
      edit:false
    };
  },
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime());
    let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
    if(!this.data.DocDate) {
      this.data.DocDate = today
    }
    this.settleApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.settleList = res.Data
    })
    this.accountApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.accountList = res.Data
    })
    this.recApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.recCon = res.Data
    })
    // this.optApi.getStandingStock().then(res => {
    //   this.eqType = res.Data
    // })
      this.optApi.list({ Code: "SALE" }).then(res => {
        
      res.Data.forEach(e=>{
        if(e.OptText=='ShowTax'){
          
          this.data.ShowTax = Number(e.OptValue)
        }
        if(e.OptText=='DisposeTax'){
          this.data.DisposeTax = e.OptValue
        }
      })
    })
  },
  methods: {
    setSupplier(data) {
      this.data.CustomerId = data.TradeUnitId;
      this.data.CustomerName = data.TradeUnitName;
      this.data.CustomerType = data.TradeUnitType;
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    setOrder(e) {
      
      e.SourceOrderId=e.OrderId
      if(this.data.OrderId==0){
        e.OrderId=0
      }else{
        e.OrderId=this.data.OrderId
      }
      // this.data=e
      this.data.CustomerName = e.CustomerName
      this.data.CustomerType = e.CustomerType
      this.data.CustomerId = e.CustomerId
      this.data.SourceOrderId = e.SourceOrderId
      this.data.ReceiptConditionId = e.ReceiptConditionId==0?null:e.ReceiptConditionId
      this.data.SourceOrderId = e.SourceOrderId
      this.data.SourceOrderNo = e.OrderNo
      // this.data.SourceOrderType=1
      console.log(e,'eeeeeeeeeeeee')
      // this.data.SourceOrderNo = e.OrderNo
      // this.data.SourceOrderId = e.OrderId
      this.$refs.dialogList.getDataFromOrder(e.SourceOrderId)
    },
    addOrder() {
      this.$refs.orderDialog.open().then((that) => {
        that.getData({NoAppend:true});
      });
    },
    closeFun(){
      this.close();
   this.$refs.dialogList.tableData=[
           {
              T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: "",
          GoodsName: "",
          GoodsId:"",
          Model:"",
          UnitId: 0,
          UnitName:"",
          Quantity: 0,
          Quantity1: 0,
          Quantity2: 0,
          BatchNo:"",
          Offer:  0,
          Discount: 100,
          Price: 0,
          ExistQuantity:  0,
          AvailableQuantity:  0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost:  0,
          GrossProfit: 0,
          Remark: "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: "",
          UnitId:"",
          UnitId1:"",
          UnitId2:""
        }
   ]
   this.recList=[]
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      
      this.data.CustomerId = e.Id
      this.data.CustomerName = e.Name
      this.data.CustomerType = e.TradeUnitType
      this.data.ClerkId = e.EmpId
      this.data.ClerkName = e.EmpName
    },
    getList(list) {
      
      this.tableData = list
      let Amount = null
      let TaxAmount = null
      let ReceiptAmount = this.data.ReceiptAmount || 0
      list.forEach(item => {
        if(item.T !=2) {
          Amount += Number(item.Amount)
          TaxAmount += Number(item.TaxAmount)
        }
      })
      this.data.Amount = Amount
      this.data.TaxAmount = TaxAmount
      this.data.NoTaxAmount = Amount - TaxAmount
      this.data.RemainAmount = Amount - ReceiptAmount
    },
    saChange(index) {
      if(this.recList[index].OrderReceiptId&&this.recList!==1) {
        this.recList[index].T = 1
      }
    },
    recChange(index,type) {
      
      let ReceiptAmount = 0
      let Amount = this.data.Amount
      if(!Amount) {
        Amount = 0
      }
      this.recList.forEach(item => {
        if(item.ReceiptAmount) {
          ReceiptAmount += Number(item.ReceiptAmount)
        }
      })
      if(type!="del") {
        if(this.recList[index].T !== 0 ) {
          this.recList[index].T = 1
        }
      }
      this.data.ReceiptAmount = Number(ReceiptAmount)
      this.data.RemainAmount = this.data.Amount - this.data.ReceiptAmount
    },
    add() {
      this.recList.push({
        T: 0, 
        DocReceiptId: 0,
        OrderReceiptId: 0,
        OrderId: this.data.OrderId,
        SettleId: null,
        AccountId: null,
        ReceiptAmount: 0,
        AddTime: this.data.DocDate
      });
    },
    del(index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if(this.recList[index].T!==0) {
          this.recList[index].T = 2
          this.recDel.push(this.recList[index])
        }
        this.recList.splice(index, 1)
        this.recChange(index,"del")
      });
    },
    addEmp() {
      // let ids = this.PriAdjustEmpList.map((x) => x.EmpId);
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId
      this.data.ClerkName = e.EmpName
    },
    examine() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.examine(this.data.OrderId).then(res => {
          if(res.Code ==0) {
            this.$message.success("审核成功")
            this.readonly = true
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm("确认弃审吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.cancelExamine(this.data.OrderId).then(res => {
          if(res.Code ==0) {
            this.$message.success("弃审成功")
            this.readonly = false
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    onCreateOpened() {
      this.edit=false
      this.canExa = false
      this.readonly = false
      this.cList = JSON.parse(sessionStorage.getItem("cList"))
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.tableData = [
         {
              T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: "",
          GoodsName: "",
          GoodsId:"",
          Model:"",
          UnitId: 0,
          UnitName:"",
          Quantity: 0,
          Quantity1: 0,
          Quantity2: 0,
          BatchNo:"",
          Offer:  0,
          Discount: 100,
          Price: 0,
          ExistQuantity:  0,
          AvailableQuantity:  0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost:  0,
          GrossProfit: 0,
          Remark: "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: "",
          UnitId:"",
          UnitId1:"",
          UnitId2:""
        }
      ]
      var user = this.$store.state.user;
      console.log('user',user)
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.billApi.getDefaultSerialNo("销售订单").then(res => {
        if(res.Code==0&&res.Data) {
          this.data.OrderNo = res.Data
        } else if(res.Code==0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    onEditOpened(row) {
      this.edit=true
      if(sessionStorage.getItem('check')==='1') {
        this.canExa = true
        this.readonly = true
        sessionStorage.removeItem('check')
      } else {
        this.canExa = false
        this.readonly = false
      }
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.getData()
      this.cList = JSON.parse(sessionStorage.getItem("cList"))
      if(this.data.ReceiptConditionId == 0) {
        this.data.ReceiptConditionId = null
      }
      this.recList = this.data.Receipts
    },
    onBeforeSave() {
       
      let tableData = this.$refs.dialogList.tableData;
      let tableDel = this.$refs.dialogList.tableDel;
      let tb = []
      if(tableData.length==0 || !tableData.some(v=>v.GoodsId)) {
        this.$message.error("请填写商品列表");
        return false;
      }
      for(var i = 0; i < tableData.length; i++) {
        if(tableData[i].GoodsId){
        if(!(tableData[i].Quantity > 0)) {
          this.$message.error("请填写正确数量");
          return false;
        }
        if(!tableData[i].Discount) {
          tableData[i].Discount = 100
        }
        if(this.eqType===1) {
          if(tableData[i].Quantity > tableData[i].ExistQuantity) {
            this.$message.warning("存在商品数量大于现存量")
          }
        }
        if(this.eqType===2) {
          if(tableData[i].Quantity > tableData[i].ExistQuantity) {
            this.$message.error("数量不可大于现存量")
            return false
          }
        }
        if(!tableData[i].TaxRate) {
          tableData[i].TaxRate = 0
        }
        if(!tableData[i].Discount) {
          tableData[i].Discount = 100
        }
        if(!tableData[i].UnitName) {
          tableData[i].UnitName = ""
        }
        if(tableData[i].T===0||tableData[i].T===1) {
          this.$delete(tableData[i],'unit')
          this.$delete(tableData[i],'Rate1')
          this.$delete(tableData[i],'Rate2')
          tb.push(tableData[i])
        }
        }
      }
      // 
      this.data.Goods = tb.concat(tableDel)
      this.data.Goods = this.data.Goods.map((x) => {
          return this.$commonJs.obj.removeNullKey(x);
      });
      // if(!this.data.RemainAmount&&this.data.RemainAmount!==0||this.recList.length==0) {
      //   this.$message.error("请填写收款信息");
      //   return false
      // }
      if(this.data.ReceiptConditionId===null) {
        this.data.ReceiptConditionId = 0
      }
      let rec = []
      this.recList.forEach(item => {
        if(item.T||item.T===0) {
          rec.push(item)
        }
      })
      for(var i = 0; i < rec.length; i++) {
        if(!rec[i].SettleId) {
          this.$message.error("请选择结算方式");
          return false
        }
        if(!rec[i].AccountId) {
          this.$message.error("请选择收款账号");
          return false
        }
        if(!(rec[i].ReceiptAmount > 0)) {
          this.$message.error("请填写正确收款金额");
          return false
        }
      }
      this.data.Receipts = rec.concat(this.recDel)
      // this.data.Receipts.forEach(item => {
      //   if(!item.SettleId) {
      //     item.SettleId = 0
      //   }
      //   if(!item.AccountId) {
      //     item.AccountId = 0
      //   }
      // })
      
      return true
    },
  },
};
</script>
<style lang="scss">
  .is-disabled {
    input,textarea {
      background-color: #fff !important;
      color: #333 !important;
    }
  }
</style>